export function rateFileSnackbarTextSuccess(rateFileName: string) {
	return `${rateFileName} rate file is complete!`;
}

export function rateFileSnackbarTextFailed(rateFileName: string) {
	return `${rateFileName} rate file has errors. Download the file to view the errors and try again by creating a new rate file.`;
}

export function getShowSnackbarData(
	rateFileName: string,
	variant: 'confirmation' | 'error'
) {
	return {
		message:
			variant === 'confirmation'
				? rateFileSnackbarTextSuccess(rateFileName)
				: rateFileSnackbarTextFailed(rateFileName),
		variant,
		open: true,
	};
}

export function formattedDate(date: string) {
	return date && date.length === 8
		? date
				.slice(4, 6)
				.concat('/')
				.concat(date.slice(6, 8))
				.concat('/')
				.concat(date.slice(0, 4))
		: '';
}
